import React from 'react';
import classNames from 'classnames';
import { Crown } from 'lucide-react';

export const GifPreviewCard = ({
  label,
  value,
  type,
  isSelected,
  isPremium,
  isDisabled,
  onClick,
  className
}) => {
  const getPreviewPath = () => {
    const baseUrl = '/previews';
    const typeMap = {
      videoStyle: 'video-styles',
      cameraMovement: 'camera-movements'
    };
    
    if (value === 'not_specified') {
      return null;
    }
    
    // Convert camelCase or underscore to hyphenated format
    const hyphenatedValue = value
      .replace(/_/g, '-') // Replace underscores with hyphens
      .replace(/([a-z])([A-Z])/g, '$1-$2') // Convert camelCase to hyphenated
      .toLowerCase();
    
    const fileName = `${hyphenatedValue}-preview.gif`;
    return `${baseUrl}/${typeMap[type]}/${fileName}`;
  };

  const previewPath = getPreviewPath();

  return (
    <div
      onClick={onClick}
      className={classNames(
        'relative w-full transition-all duration-200 rounded-lg overflow-hidden cursor-pointer',
        'hover:ring-2 hover:ring-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500',
        {
          'ring-2 ring-emerald-500': isSelected,
          'opacity-50 cursor-not-allowed': isDisabled,
        },
        className
      )}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick?.();
        }
      }}
    >
      <div className="aspect-video relative">
        {previewPath ? (
          <img
            src={previewPath}
            alt={label}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = '/previews/placeholder-preview.gif';
            }}
          />
        ) : (
          <div className="w-full h-full bg-gray-800 flex items-center justify-center">
            <span className="text-gray-400 text-sm">Not Specified</span>
          </div>
        )}
        
        {isPremium && (
          <div className="absolute top-2 right-2 bg-emerald-500 rounded-full p-1">
            <Crown className="w-4 h-4 text-gray-900" />
          </div>
        )}
      </div>
      
      <div className="p-2 bg-gray-700">
        <p className="text-sm font-medium text-gray-200">
          {label.replace(' (Premium)', '')}
        </p>
      </div>
    </div>
  );
};